import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Button, LoadingIcon } from 'bc-front-sagacomponents';
import React from 'react';
import { Translation } from 'react-i18next';
import { ErrorApi } from '../../types';

interface Props {
  children: any;
  error?: ErrorApi;
  loading?: boolean;
  onRetry?(): void;
  classes?: any;
  className?: any;
  table?: boolean;
  messageFetching?: string;
}

const styles = () => ({
  button: {
    marginTop: 16,
  },
});

/**
 * Composant pour gérer les chargements en cours :
 * - Affichage d'un loader si chargement en cours
 * - Affichage d'un message et d'un bouton "Réessayer" en cas d'erreur
 * - Affichage des enfants sinon
 */
function LoadingErrorBoundary(props: Props) {
  const { children, classes, error, loading, onRetry, table, messageFetching } = props;

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      window.location.reload();
    }
  };
  if (loading) {
    if (table) {
      return (
        <td colSpan={7} style={{ textAlign: 'center' }}>
          <LoadingIcon />
          {messageFetching && <Typography variant="body2">{messageFetching}</Typography>}
        </td>
      );
    } else {
      return (
        <div style={{ textAlign: 'center' }}>
          <LoadingIcon defaultColor />
        </div>
      );
    }
  } else if (error) {
    if (table) {
      return (
        <td colSpan={7} style={{ textAlign: 'center' }}>
          {error && error.response && error.response.data && error.response.data.description ? (
            <Typography>{error.response.data.description}</Typography>
          ) : (
            <Typography>Une erreur est survenue</Typography>
          )}
          <Button color="primary" title={'Réessayer'} onClick={handleRetry} className={classes.button} />
        </td>
      );
    } else {
      return (
        <div style={{ textAlign: 'center' }}>
          {error && error.response && error.response.data && error.response.data.description ? (
            <Typography>{error.response.data.description}</Typography>
          ) : (
            <Translation>{(t) => <Typography>{t('errors.erreurSurvenue')}</Typography>}</Translation>
          )}
          <Button color="primary" title={'Réessayer'} onClick={handleRetry} className={classes.button} />
        </div>
      );
    }
  }
  return children;
}

export default withStyles(styles)(LoadingErrorBoundary);
